/**
 * Route: /admin/ingest — ingest pipeline health overview.
 *
 * Admin-only. The underlying `/system/ingest-health` endpoint may return
 * a 404 when no data is available; the screen handles that gracefully.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

import { me } from '../../lib/auth';
import { toast } from '../../lib/toast';
import { IngestHealth } from '../../features/admin/IngestHealth';

export const Route = createFileRoute('/admin/ingest')({
  beforeLoad: async () => {
    try {
      const profile = await me();
      if (profile.platform_role !== 'admin') {
        toast({
          tone: 'error',
          message: 'Alleen admins hebben toegang tot deze pagina.',
        });
        throw redirect({ to: '/' });
      }
    } catch (err) {
      if (err && typeof err === 'object' && 'to' in err) {
        throw err;
      }
      throw redirect({ to: '/login' });
    }
  },
  component: IngestHealth,
});
